import * as React from 'react';

export default () => <div>Impressum</div>;
